const theme = { 
  black: '#212529',
  fontFamily: 'Schibsted Grotesk, sans-serif',
  lineHeight: '1.375rem',
  headings: { 
    fontFamily: 'Viga, sans-serif',
    fontWeight: 400,
    sizes: {
      h1: {
        fontSize: '1.75rem', // 28px
        lineHeight: 1.285, // 36px
      },
      h2: {
        lineHeight: 1.272, // 30px
      }
    }
  },
  colors: { spotify: ['#1DB954'] },
  spacing: {
    xs: '0.5rem', // 8px
  },
  components: {
    Alert: {
      styles: {
        title: {
          marginBottom: '0.25rem', // 4px
        },
      },
    },
    Button: {
      styles: {
        root: {
          height: '2.75rem', // 44px
          paddingLeft: '1rem', 
          paddingRight: '1rem',
        },
        label: {
          fontSize: '0.875rem', // 14px
        },
        leftIcon: {
          marginRight: '0.625rem', // 10px
        }
      },
    },
  },
}

export default theme;